function phone(number) {
  if (!number) return ''
  if (number.length < 4) return number
  if (number.length < 7) return number.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{1,3})/, '($1) $2')
  if (number.length < 11) return number.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{1,4})/, '($1) $2-$3')
  return number.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
}

export default phone
